module.exports = __webpack_public_path__ + "img/L 11.191143f5.png";